import LinearProgress from '@mui/material/LinearProgress';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';
import { checkAccess } from '../../api/mobileapi';
import { AccessPointData } from '../../api/types';
import { AdamsError } from '../../utils/errors';
import { GlobalError } from '../GlobalError/GlobalError';
import { useHomeData } from '../LoadHomeData/HomeDataProvider';
import { useTranslations } from '../Translations/TranslationsProvider';

interface AccessInformationProps {
    children: (props: { accessInformation: AccessPointData; translations: Record<string, string> }) => React.ReactNode;
    enabled: boolean;
}

export const AccessInformation: React.FC<AccessInformationProps> = ({ enabled, children }) => {
    const { currentLanguage } = useHomeData();
    const { translations } = useTranslations();
    const { accesspointcode } = useParams();

    const {
        data: accessInformation,
        error: accessPointError,
        isLoading,
    } = useQuery<AccessPointData, AdamsError>(
        ['checkAccess', accesspointcode],
        () => checkAccess({ language: currentLanguage, accessPointCode: accesspointcode! }),
        {
            enabled,
        }
    );

    if (!accessPointError && (!accessInformation || !translations || isLoading)) {
        return <LinearProgress />;
    }

    if (accessPointError) {
        return <GlobalError error={accessPointError} translations={translations} />;
    }

    return <>{children({ accessInformation, translations })}</>;
};
